import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/assets";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 halftone">
      <img src={ASSETS.crying} alt="404" className="w-48 animate-floaty" data-testid="notfound-mascot" />
      <h1 className="headline text-neon text-6xl mt-6">404</h1>
      <p className="font-display font-900 text-cream uppercase text-xl mt-3">Yep. You got robbed again.</p>
      <p className="font-mono text-dim mt-2">This page vanished faster than your last altcoin bag.</p>
      <Link to="/" className="btn-neon mt-8" data-testid="notfound-home">Back To Safety</Link>
    </div>
  );
}
